import { environment } from './../environments/environment';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReportsService } from '../service/reports.service';
import { ChartService } from '../service/chart.service';
import { PdfService } from '../service/pdf.service';

interface BinData {
  bin_id: string;
  bin_gps?: string;
  bin_location: string;
  thing_name: string;
  bin_usage: string;
  bin_address: string;
  legal_name: string;
  market_segment: string;
  threshold: number;
  bin_height: number;
  total_volume: number;
}

@Component({
    selector: 'app-pdf-generator',
    templateUrl: './pdf-generator.component.html',
    styleUrls: ['./pdf-generator.component.css'],
    standalone: false
})
export class PdfGeneratorComponent {
  @ViewChild('usageCanvas') usageCanvas!: ElementRef;
  @ViewChild('marketCanvas') marketCanvas!: ElementRef;
  @ViewChild('countCanvas') countCanvas!: ElementRef;
  @ViewChild('tonnageCanvas') tonnageCanvas!: ElementRef;
  @ViewChild('subgroupTonnageCanvas') subgroupTonnageCanvas!: ElementRef;
  @ViewChild('usageTonnageCanvas') usageTonnageCanvas!: ElementRef;
  @ViewChild('marketTonnageCanvas') marketTonnageCanvas!: ElementRef;
  constructor(public reports: ReportsService,
              public charts: ChartService,
              public pdf: PdfService) {}

  ngOnInit(){
    this.pdf.start = '2025-05-01';
    this.pdf.end = '2025-06-31';
    this.pdf.things = [
      'MWS-B01-134',
      'MWS-B01-138',
      'MWS-B01-139',
      'MWS-B01-140',
      'MWS-B01-141',
      'MWS-B01-143',
      'MWS-B01-145',
      'MWS-B01-146',
      'MWS-B01-148',
    ]
  }

  async ngAfterViewInit() {
    this.pdf.usageCanvas = this.usageCanvas;
    this.pdf.marketCanvas = this.marketCanvas;
    this.pdf.countCanvas = this.countCanvas;
    this.pdf.tonnageCanvas = this.tonnageCanvas;
    this.pdf.usageTonnageCanvas = this.usageTonnageCanvas;
    this.pdf.marketTonnageCanvas = this.marketTonnageCanvas;
    this.pdf.subgroupTonnageCanvas = this.subgroupTonnageCanvas;
  }
}
